import { Fragment } from 'react'
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import { formatDate, formatTo0Decimal, getFontSize, getSpecList, isEmpty, isNotEmpty } from '../../common/util.services';
import { LOGO } from '../../common/constants';

const PrintMasterPojo = (props: any) => {
  let pojoData = props.data[0];
  let pojoDataAll = props.data;
  const styles = StyleSheet.create({
    page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5, flexDirection: 'column' },
    spaceBetween: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', color: "#3E3E3E" },
    titleContainer: { flexDirection: 'row', marginTop: 15 },
    theader: { marginTop: 20, fontSize: 10, fontStyle: 'normal', paddingTop: 4, paddingLeft: 7, flex: 1, fontWeight: 'bold',
               borderColor: 'black', borderWidth: 0.5 },
    theader2: { flex: 3, borderWidth: 0.5, borderColor: 'black' },
    tbody: { fontSize: 9, paddingTop: 4, paddingLeft: 7, flex: 1, borderColor: 'black', borderWidth: 0.5 },
    total: { fontSize: 9, paddingTop: 4, paddingLeft: 7, flex: 1, borderColor: 'black', borderWidth: 0.5 },
    total2: { flex: 3, borderWidth: 0.5, borderColor: 'black' },
    tbody2: { flex: 3, borderWidth: 0.5, borderColor: 'black'}
  });

  function getSpecListData(detail: any) {
    let data = {type: detail.inputType, input: detail.inputName};
    return getSpecList(data);
  };

  function getSpecValue(inputSpec: any, pojoData: any) {
    switch (inputSpec){
      case 'spec1': return pojoData.spec1;
      case 'spec2': return pojoData.spec2;
      case 'spec3': return pojoData.spec3;
      case 'spec4': return pojoData.spec4;
      case 'spec5': return pojoData.spec5;
      case 'spec6': return pojoData.spec6;
      case 'spec7': return pojoData.spec7;
      case 'spec8': return pojoData.spec8;
      case 'spec9': return pojoData.spec9;
      case 'spec10': return pojoData.spec10;
      case 'spec11': return pojoData.spec11;
      case 'spec12': return pojoData.spec12;
      case 'spec13': return pojoData.spec13;
      case 'spec14': return pojoData.spec14;
      case 'spec15': return pojoData.spec15;
      default: return '';
    }
  }

  function getSpec(detail: any, inputSpec: any) {
    let specName = '';
    let specList = getSpecListData(detail);
    specList.map((spec: any) => {
      if(inputSpec === spec.fieldObject) {
        specName = spec.fieldName;
      }
    });

    return isEmpty(getSpecValue(inputSpec, detail)) ? '' : specName + ' - ' + getSpecValue(inputSpec, detail);
  }

  const Header = () => (
    <View style={styles.titleContainer}>
      <View>
        <Image style={{width: 90}} src={LOGO} />
      </View>
      <View style={{position: 'absolute', left: 0, right: 0, alignItems: 'center', justifyContent: 'center', zIndex: -1}}>
        <Text style={{fontSize: 14, textAlign: 'center', fontWeight: 'bold'}}>
          {'Purchase Order' === pojoData.pojoType ? 'PURCHASE ORDER' : 'JOB ORDER'}
        </Text>
      </View>
    </View>
  );

  const InvoiceDetails = () => (
    <View style={styles.titleContainer}>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Invoice To</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>LFH Home Private Limited</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>40-D, Periyar Nagar 2nd Cross</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>Sengunthapuram PO, Karur</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>Tamil Nadu, 639002</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>GSTIN: 33AAECL3320P1ZI</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60, fontWeight: 'bold'}}>Consignee (Ship To)</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>LFH Home Private Limited</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>40-D, Periyar Nagar 2nd Cross</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>Sengunthapuram PO, Karur</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>Tamil Nadu, 639002</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 60}}>GSTIN: 33AAECL3320P1ZI</Text>
      </View>
      <View style={{marginLeft: 60}}>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Supplier (Bill From)</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.supplier}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.address1}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.address2}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.address3}</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{'GSTIN: ' + pojoData.gstin}</Text>
      </View>
    </View>
  );

  const OtherDetails = () => (
    <View style={styles.titleContainer}>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>
          {'Purchase Order' === pojoData.pojoType ? 'PO No.' : 'JO No.'}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.masterPojo}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Payment Mode</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.paymentMode}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', fontWeight: 'bold'}}>Transport Mode</Text>
        <Text style={{fontSize: 10, textAlign: 'center'}}>{pojoData.transportMode}</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45, fontWeight: 'bold'}}>
          {'Purchase Order' === pojoData.pojoType ? 'PO Date' : 'JO Date'}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>{formatDate(pojoData.poDate)}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45, fontWeight: 'bold'}}>Reference</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>{pojoData.reference}</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45, fontWeight: 'bold'}}>Destination</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>{pojoData.destination}</Text>
      </View>
      <View>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45, fontWeight: 'bold'}}>Terms Of Delivery</Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm1) ? '- ' + pojoData.deliveryTerm1 : ''}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm2) ? '- ' + pojoData.deliveryTerm2 : ''}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm3) ? '- ' + pojoData.deliveryTerm3 : ''}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm4) ? '- ' + pojoData.deliveryTerm4 : ''}
        </Text>
        <Text style={{fontSize: 10, textAlign: 'center', marginLeft: 45}}>
          {isNotEmpty(pojoData.deliveryTerm5) ? '- ' + pojoData.deliveryTerm5 : ''}
        </Text>
      </View>
    </View>
  );

  const TableHead = () => (
    <View style={{ width: '100%', flexDirection: 'row'}}>
      <View style={[styles.theader, styles.theader2]}>
        <Text>Description</Text>
      </View>
      <View style={styles.theader}>
        <Text>Delivery Date</Text>
      </View>
      <View style={styles.theader}>
        <Text>Quantity</Text>
      </View>
      <View style={styles.theader}>
        <Text>Rate</Text>
      </View>
      <View style={styles.theader}>
        <Text>Amount</Text>
      </View>
    </View>
  );

  const TableBody = () => (
    <Fragment>
      {pojoDataAll.map((detail: any) => (
        <View style={{ width: '100%', flexDirection: 'row' }}>
          <View style={[styles.tbody, styles.tbody2]} wrap={false}>
            <Text style={{fontWeight: "bold"}}>{detail.rowId + '. ' + detail.pojoCode}</Text>
            <Text style={{fontWeight: "bold"}}>
              {detail.inputName + ('Purchase Order' !== detail.pojoType ? '' : ' (HSN Code - ' + 
                                    (isNotEmpty(detail.hsnCode) ? detail.hsnCode : 'NA') + ')')}
            </Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{'Code : ' + detail.inputCode}</Text>
            <Text style={{marginLeft: 10, fontWeight: 'bold', fontStyle: 'italic', fontSize: getFontSize('Desc : ' + detail.description)}}>
              {'Desc : ' + detail.description}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec1'))}}>{getSpec(detail, 'spec1')}</Text>
            {'Fabric' === detail.inputName && 
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec15'))}}>{getSpec(detail, 'spec15')}</Text>}
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec2'))}}>{getSpec(detail, 'spec2')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec3'))}}>{getSpec(detail, 'spec3')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec4'))}}>{getSpec(detail, 'spec4')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec5'))}}>{getSpec(detail, 'spec5')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec6'))}}>{getSpec(detail, 'spec6')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec7'))}}>{getSpec(detail, 'spec7')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec8'))}}>{getSpec(detail, 'spec8')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec9'))}}>{getSpec(detail, 'spec9')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec10'))}}>{getSpec(detail, 'spec10')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec11'))}}>{getSpec(detail, 'spec11')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec12'))}}>{getSpec(detail, 'spec12')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec13'))}}>{getSpec(detail, 'spec13')}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec14'))}}>{getSpec(detail, 'spec14')}</Text>
            {'Fabric' !== detail.inputName && 
            <Text style={{marginLeft: 10, fontStyle: 'italic', fontSize: getFontSize(getSpec(detail, 'spec15'))}}>{getSpec(detail, 'spec15')}</Text>}
            <Text style={{marginLeft: -7}}>{'___________________________________________'}</Text>
            {isEmpty(detail.cgst) ? '' : <Text style={{marginLeft: 150, fontStyle: 'italic', fontWeight: 'bold'}}>{'CGST'}</Text>}
            {isEmpty(detail.sgst) ? '' : <Text style={{marginLeft: 150, fontStyle: 'italic', fontWeight: 'bold'}}>{'SGST'}</Text>}
            {isEmpty(detail.igst) ? '' : <Text style={{marginLeft: 150, fontStyle: 'italic', fontWeight: 'bold'}}>{'IGST'}</Text>}
            <Text style={{marginLeft: 150, fontStyle: 'italic', fontWeight: 'bold'}}>{'Sub-Total'}</Text>
          </View>
          <View style={styles.tbody}>
            <Text>{formatDate(detail.deliveryDate)} </Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec1')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec2')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec3')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec4')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec5')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec6')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec7')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec8')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec9')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec10')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec11')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec12')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec13')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec14')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec15')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: -7}}>{'_______________'}</Text>
          </View>
          <View style={styles.tbody}>
            <Text>{formatTo0Decimal(getPlannedOutput(detail)) + ' ' + getOutputUom(detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec1')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec2')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec3')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec4')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec5')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec6')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec7')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec8')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec9')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec10')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec11')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec12')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec13')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec14')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec15')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: -7}}>{'_______________'}</Text>
          </View>
          <View style={styles.tbody}>
            <Text>{detail.printCurrency + getUnitCost(detail).toFixed(2) + ' / ' + getOutputUom(detail)}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec1')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec2')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec3')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec4')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec5')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec6')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec7')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec8')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec9')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec10')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec11')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec12')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec13')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec14')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec15')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: -7}}>{'_______________'}</Text>
            <Text style={{fontStyle: "italic"}}>{getGSTText(detail.cgst)}</Text>
            <Text style={{fontStyle: "italic"}}>{getGSTText(detail.sgst)}</Text>
            <Text style={{fontStyle: "italic"}}>{getGSTText(detail.igst)}</Text>
          </View>
          <View style={[styles.tbody]}>
            <Text>{detail.printCurrency + formatTo0Decimal(getPOValue(detail))}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{' '}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec1')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec2')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec3')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec4')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec5')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec6')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec7')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec8')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec9')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec10')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec11')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec12')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec13')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec14')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: 10, fontStyle: 'italic'}}>{isNotEmpty(getSpec(detail, 'spec15')) ? ' ' : ''}</Text>
            <Text style={{marginLeft: -7}}>{'_______________'}</Text>
            <Text style={{fontWeight: 'bold', fontStyle: "italic"}}>
            {isEmpty(detail.cgst) ? '' : detail.printCurrency + formatTo0Decimal(calculateGST(getPOValue(detail), detail.cgst))}</Text>
            <Text style={{fontWeight: 'bold', fontStyle: "italic"}}>
            {isEmpty(detail.sgst) ? '' : detail.printCurrency + formatTo0Decimal(calculateGST(getPOValue(detail), detail.sgst))}</Text>
            <Text style={{fontWeight: 'bold', fontStyle: "italic"}}>
            {isEmpty(detail.igst) ? '' : detail.printCurrency + formatTo0Decimal(calculateGST(getPOValue(detail), detail.igst))}</Text>
            <Text style={{fontWeight: 'bold', fontStyle: 'italic'}}>{detail.printCurrency + formatTo0Decimal(
                                                                     getPOValue(detail) + 
                                                                     calculateGST(getPOValue(detail), detail.cgst) +
                                                                     calculateGST(getPOValue(detail), detail.sgst) +
                                                                     calculateGST(getPOValue(detail), detail.igst))}</Text>
          </View>
        </View>
      ))}
    </Fragment>
  );

  function getGSTText(value: any) {
    return isEmpty(value) ? '' : value + '%';
  }

  function calculateGST(cost: any, gst: any) {
    return isEmpty(gst) ? 0 : Math.ceil(cost * gst/100);
  }

  function calculateTotalGST(type: any) {
    let gstAmt = 0;
    for(let i = 0; i < pojoDataAll.length; ++i) {
      if('CGST' === type) {
        gstAmt += Math.ceil(getPOValue(pojoDataAll[i]) * pojoDataAll[i].cgst/100);
      } else if('SGST' === type) {
        gstAmt += Math.ceil(getPOValue(pojoDataAll[i]) * pojoDataAll[i].sgst/100);
      } else if('IGST' === type) {
        gstAmt += Math.ceil(getPOValue(pojoDataAll[i]) * pojoDataAll[i].igst/100);
      }
    }

    return gstAmt;
  }

  function getUnitCost(detail: any) {
    return detail.printUnitCost;
  }

  function getPlannedOutput(detail: any) {
    return detail.printOutput;
  }

  function getOutputUom(detail: any){
    return detail.printUom;
  }

  function getPOValue(detail: any) {
    return Math.ceil(getUnitCost(detail) * getPlannedOutput(detail));
  }

  function getTotalPOValue() {
    let amount = 0;
    for(let i = 0; i < pojoDataAll.length; ++i) {
      amount += Math.ceil(getUnitCost(pojoDataAll[i]) * getPlannedOutput(pojoDataAll[i]));
    }

    return amount + calculateTotalGST('CGST') + calculateTotalGST('SGST') + calculateTotalGST('IGST');
  }

  const TableTotal = () => (
    <View style={{ width: '100%', flexDirection: 'row' }} wrap={false}>
      <View style={[styles.total, styles.total2]}>
        <Text style={{fontWeight: 'bold', marginLeft: 130}}>{isNotEmpty(pojoData.totalQty) && isNotEmpty(pojoData.totalUnitRate) ? 
                                                             'Total Qty / Rate' : isNotEmpty(pojoData.totalQty) ?
                                                             'Total Quantity' : ''}</Text>
        <Text style={{fontWeight: 'bold', marginLeft: 130}}>{isEmpty(pojoData.cgst) ? '' : 'Total CGST'}</Text>
        <Text style={{fontWeight: 'bold', marginLeft: 130}}>{isEmpty(pojoData.sgst) ? '' : 'Total SGST'}</Text>
        <Text style={{fontWeight: 'bold', marginLeft: 130}}>{isEmpty(pojoData.igst) ? '' : 'Total IGST'}</Text>
        <Text style={{fontWeight: 'bold', marginLeft: 130}}>Total Amount</Text>
      </View>
      <View style={styles.total}>
        <Text></Text>
      </View>
      <View style={styles.total}>
        <Text>{isNotEmpty(pojoData.totalQty) ? (formatTo0Decimal(pojoData.totalQty) + ' ' + pojoData.printUom) : ''}</Text>
      </View>
      <View style={styles.total}>
        <Text>{isNotEmpty(pojoData.totalUnitRate) ? (pojoData.printCurrency + pojoData.totalUnitRate.toFixed(2) + 
                                                    ' / ' + pojoData.printUom) : ''}</Text>
      </View>
      <View style={styles.total}>
        <Text style={{fontWeight: 'bold'}}>{isNotEmpty(pojoData.totalQty) ? ' ' : ''}</Text>
        <Text style={{fontWeight: 'bold'}}>
          {isEmpty(pojoData.cgst) ? '' : pojoData.printCurrency + formatTo0Decimal(calculateTotalGST('CGST'))}
        </Text>
        <Text style={{fontWeight: 'bold'}}>
          {isEmpty(pojoData.sgst) ? '' : pojoData.printCurrency + formatTo0Decimal(calculateTotalGST('SGST'))}
        </Text>
        <Text style={{fontWeight: 'bold'}}>
          {isEmpty(pojoData.igst) ? '' : pojoData.printCurrency + formatTo0Decimal(calculateTotalGST('IGST'))}
        </Text>
        <Text style={{fontWeight: 'bold'}}>{pojoData.printCurrency + formatTo0Decimal(getTotalPOValue())}</Text>
      </View>
    </View>
  );

  const OtherText = () => (
    <View style={{ width: '100%', flexDirection: 'row'}}>
      <View wrap={false}>
        <Text style={{fontSize: 10, marginTop: 10, fontStyle: 'italic'}}>- This is a computer generated document and signature is not required</Text>
        <Text style={{fontSize: 10, marginTop: 0, fontStyle: 'italic'}}>- All disputes are subject to Karur jurisdiction</Text>
      </View>
      <View wrap={false}>
        <Text style={{fontSize: 10, marginTop: 25, marginLeft: 110}}>Authorised Signatory</Text>
      </View>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header/>
        <InvoiceDetails />
        <OtherDetails />
        <TableHead />
        <TableBody />
        <TableTotal />
        <OtherText />
      </Page>
    </Document>
  )
}

export default PrintMasterPojo